'use strict';

export default class EditController {

  /*@ngInject*/
  constructor($http, $state, toaster, $stateParams) {
    this.$http = $http;
    this.$state = $state;
    this.toaster = toaster;
    this.$stateParams = $stateParams;

  }

  $onInit() {
    this.getCarousel();
  }

  getCarousel() {
    this.$http.get(`/api/carousels/${this.$stateParams.id}`)
      .then(res => {
        this.carousel = res.data;
      });
  }

  save() {
    if (!this.checkData()) {
      return;
    }
    this.$http.put(`/api/carousels/${this.carousel._id}`, this.carousel).then(res => {
      this.$state.go('carousel.show', {
        id: res.data._id
      });
    });
  }

  checkStr(str) {
    if (str && typeof str == 'string') {
      str = str.trim();
    }
    return str;
  }

  checkArr(arr) {
    let res = false;
    arr.forEach(item => {
      if (item.trim().length > 0) {
        res = true;
      }
    });
    return res;
  }

  checkData() {
    if (this.checkStr(this.carousel.model) && this.carousel.deviceWidth && this.carousel.deviceHeight && this.checkArr(this.carousel.devices)) {
      return true;
    }

    this.toaster.pop({
      type: 'error',
      title: '请填写必填项',
      timeout: 3 * 1000
    });
    return false;
  }

}



// WEBPACK FOOTER //
// ./client/app/carousel/edit/edit.controller.js